import React from "react";
import { Image, Row, Col, Modal } from "react-bootstrap";
import STRINGS from "../../constants/strings";

export default function DeliveryOption(props) {
  const { open, closeModal, isMobile } = props;
  return (
    <Modal show={open} onHide={closeModal}>
      <Modal.Header closeButton>
        <h2 className="text-capitalize text-center">Delivery Options</h2>
      </Modal.Header>
      <Modal.Body>
        <Row sm={1} md={1} lg={2} xs={1}>
          <Col>
            <Image
              src={require("../../assets/delivery-page.jpg")}
              className="w-100"
              style={{ height: `${isMobile ? 65 : 45}wh` }}
            />
          </Col>
          <Col className=" d-flex justify-content-center">
            <div className="align-self-center">
              <div className="heading">
                <h2 className="text-capitalize text-center">
                  {STRINGS.SAME_DAY_DELIVERY}
                </h2>
              </div>
              <p className="content">{STRINGS.SAME_DAY_DELIVERY_CONTENT}</p>
              <div className="heading">
                <h2 className="text-capitalize text-center">
                  {STRINGS.INTER_STATE_DELIVERY}
                </h2>
              </div>
              <p className="content">{STRINGS.INTER_STATE_DELIVERY_CONTENT}</p>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}
